import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Checkbox, Grid, } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import DeleteModal from "../../../../components/Common/DeleteModal";
import LoadingDialog from "../../../../components/Common/LoadingDialog";
import Notification from "../../../../components/Common/Notification";
import CustomIconButton from "../../../../components/Form/CustomIconButton";
import CustomTextField from "../../../../components/Form/CustomTextField";
import { bulkDeleteConfigurationItem, createConfigurationItem, deleteConfigurationItem, getConfigurationDetails, getGeneral, resetConfigurationState, updateConfigurationItem } from "../../../../store/actions";
import "../../setting.css";
import Table from "./Table";
import CustomButton from "../../../../components/Form/CustomButton";


const ViewProductConfiguration = ({ userPermission, configurationDetails, editConfiguration, addConfiguration, delConfigItemArry, bulkDelete }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { module } = useParams();
    const [loading, setIsLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [openDel, setOpenDel] = useState({ open: false, id: "" });
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState("id");
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [editConfigurationValue, setEditConfigurationValue] = useState();
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);

    useEffect(() => {
        if (delConfigItemArry?.code === "success") {
            setNotification({
                open: true,
                msg: "Delete Successfully",
                type: "success",
            })
            setOpenDel({ open: false, id: "" });
            dispatch(resetConfigurationState())
            initData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [delConfigItemArry]);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("export-setting") && setExportable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        if (bulkDelete?.code === "success") {
            setIsLoading(false);
            setOpenDel({ open: false, id: "" });
            setNotification({
                open: true,
                msg: "Delete Successfully",
                type: "success",
            })
            dispatch(resetConfigurationState())
            setCheckedAll(false);
            setOpenDel({ open: false, id: "" });
            setSelectedRow([]);
            dispatch(getGeneral());
            initData()
        } else if (bulkDelete?.code === "invalid_configuration_item") {
            setIsLoading(false);
            setOpenDel({ open: false, id: "" });
            setNotification({
                open: true,
                msg: "Invalid configuration item",
                type: "error",
            })
            dispatch(resetConfigurationState())
            initData()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bulkDelete]);

    useEffect(() => {
        dispatch(resetConfigurationState());
    }, [])

    useEffect(() => {
        initData();
    }, [sort_by, sort])

    useEffect(() => {
        if (checkedAll && configurationDetails?.items) {
            const productListingIDs = configurationDetails.items.map((item) => item.id);
            setSelectedRow(productListingIDs);
        } else if (!checkedAll && selectedRow.length === configurationDetails?.items?.length) {
            // Only clear if all items were selected (meaning user clicked "uncheck all" header)
            setSelectedRow([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedAll, configurationDetails?.items]);

    const handleCheckboxChange = (e) => {
        setCheckedAll(false)
        let temp = []
        if (selectedRow && selectedRow?.length > 0 && selectedRow.includes(parseInt(e))) {
            temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
            setSelectedRow(temp)
        } else {
            setSelectedRow([...selectedRow, parseInt(e)])
        }
    }

    const header = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <Checkbox
                            checked={checkedAll ? checkedAll : selectedRow?.length > 0 ? selectedRow.includes(cellProps.id) : false}
                            sx={{
                                color: '#D0D0D0',
                                '&.Mui-checked': {
                                    color: "var(--bs-theme-color)",
                                },
                                paddingBlock: 0
                            }}
                            value={cellProps.id}
                            onChange={(event) => handleCheckboxChange(event.target.value, cellProps)} />
                    </React.Fragment>
                )
            },
        },
        {
            Header: "Configurations Type name",
            columnID: "name",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {
                            selectedRow === idx ?
                                <CustomTextField
                                    values={editConfigurationValue?.name}
                                    onChange={(e) => handleEditConfigurationChange('name', e)}
                                />
                                :
                                <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps.name}</div>
                        }

                    </React.Fragment>
                )
            },
            tooltipMessage: "Define the type of configuration, such as Processor or Memory, to group related options on the product page.",
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sort order",
            columnID: "sort_order",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {
                            selectedRow === idx ?
                                <CustomTextField
                                    values={editConfigurationValue?.sort_order}
                                    onChange={(e) => handleEditConfigurationChange('sort_order', e)}
                                    placeholder={'0'}
                                    type={"number"}
                                /> :
                                cellProps?.sort_order
                        }
                    </React.Fragment>
                )
            },
            tooltipMessage: "Set the display order for configurations on the product page (lower numbers appear first).",
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {
                            selectedRow === idx ?
                                <>
                                    {editable && <CustomIconButton
                                        iconName={'ri-check-line'}
                                        onClick={() => submitEditConfiguration()}
                                    />}
                                    {editable && <CustomIconButton
                                        iconName={'ri-close-line'}
                                        onClick={() => { setSelectedRow([]); setEditConfigurationValue() }}
                                    />}
                                </> :
                                <>
                                    {editable && <CustomIconButton
                                        iconName={'ri-pencil-line'}
                                        onClick={() => { handleSetEditConfiguration(idx, cellProps) }}
                                    />}
                                    {deletable && <CustomIconButton
                                        iconName={'ri-delete-bin-line'}
                                        onClick={() => setOpenDel({ open: true, id: cellProps.id })}
                                        backgroundColor={'#44d62c'}
                                        color={'white'}
                                        borderStyle={"1px solid #44d62c"}
                                    />}
                                </>
                        }

                    </React.Fragment>
                )
            },
            minWidth: 150,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    useEffect(() => {
        if (editConfiguration?.code === 'success') {
            setSelectedRow([]);
            setNotification({
                open: true,
                msg: 'Configuration edited successfully',
                type: 'success'
            })
            dispatch(resetConfigurationState())
            initData();
            setIsLoading(false);

        }
    }, [editConfiguration])

    useEffect(() => {
        if (addConfiguration?.code === 'success') {
            setSelectedRow([]);
            setNotification({
                open: true,
                msg: 'Configuration added successfully',
                type: 'success'
            })
            dispatch(resetConfigurationState());
            initData();
            setSelectedRow([]); setEditConfigurationValue()
            setIsLoading(false);

        }
    }, [addConfiguration])

    const initData = () => {
        dispatch(getConfigurationDetails({ id: module, sort_field: sort_by, sort_order: sort }));
    }

    const handleEditConfigurationChange = (field, val) => {
        setEditConfigurationValue({ ...editConfigurationValue, [field]: val });
    }

    const handleSetEditConfiguration = (idx, cellProps) => {
        setSelectedRow(idx);
        setEditConfigurationValue(cellProps);
    }

    const handleDeleteConfigurationType = (idx) => {
        if (selectedRow?.length > 0) {
            dispatch(bulkDeleteConfigurationItem({ ids: selectedRow }))

        } else {
            dispatch(deleteConfigurationItem({ id: idx }));
        }
    }
    const submitNewConfiguration = (newConfiguration) => {
        if (newConfiguration?.configuration_specific_name && newConfiguration?.sortOrder) {
            let payload = {
                configuration_id: module,
                name: newConfiguration?.configuration_specific_name || '-',
                sort_order: newConfiguration.sortOrder || 0
            };
            dispatch(createConfigurationItem({ data: payload }));
        } else {
            setNotification({
                open: true,
                msg: 'Please fill all the fields',
                type: 'error'
            })
        }
    }

    const submitEditConfiguration = () => {
        let selectedRowID = configurationDetails?.items?.[selectedRow]?.id
        let payload = {
            name: editConfigurationValue?.name,
            sort_order: editConfigurationValue.sort_order,
        }
        dispatch(updateConfigurationItem({ id: selectedRowID, data: payload }));

    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid item xs={12}>
                    <div className="d-flex justify-content-end">
                        {deletable && selectedRow && selectedRow?.length > 0 &&
                            <CustomButton
                                title={<><i className="ri-delete-bin-line" style={{ marginRight: 5 }} />Delete</>}
                                height={32}
                                borderRadius={15}
                                textColor={"white"}
                                press={() => { setOpenDel({ open: true, id: "" }) }}
                                backgroundColor={"#44d62c"}
                                borderStyle={"1px solid #44d62c"}
                            />}
                    </div>
                </Grid>
            </Grid>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading} />
                <Container fluid>
                    <DeleteModal
                        open={openDel?.open}
                        close={() => { setOpenDel({ open: false, id: "" }); setSelectedRow([]); setCheckedAll(false); }}
                        submit={() => handleDeleteConfigurationType(openDel?.id)}
                        module={'configuration'}
                    />
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        backRoute={'/settings-product-configurations'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: 'Configurations', link: "/settings-product-configurations" },
                        { title: (configurationDetails?.descriptions?.length > 0 && configurationDetails?.descriptions[0].name) || '', link: "#" },
                        ]}
                    />
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={configurationDetails?.items?.length > 0 ? configurationDetails?.items : []}
                        pageSize={configurationDetails?.items?.length}
                        totalPage={configurationDetails?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                        submitNewData={(data) => submitNewConfiguration(data)}
                        module={'view-configuration'}
                        categoryList={[]}
                        submitted={editConfiguration?.code === 'success'}
                        submittedAdd={addConfiguration?.code === 'success'}
                        creatable={creatable}
                        editable={editable}
                    />

                    {/* <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={configurationDetails?.last_page || 1}
                    /> */}
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Configuration, Login }) {
    return {
        configurationDetails: Configuration.configurationDetails.data,
        editConfiguration: Configuration.updateConfigurationItem,
        addConfiguration: Configuration.addConfigurationItem,
        userPermission: Login.permissionArry,
        delConfigItemArry: Configuration?.deleteConfigurationItem,
        bulkDelete: Configuration.bulkDeleteConfigurationItem,

    };
}

export default connect(mapStateToProps)(ViewProductConfiguration);